import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import Input from "../common/Input";
import useForm from "../../hooks/useForm";
import "animate.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import SocialBar from "../common/SocialBar";
import { Link } from "react-router-dom";

const Form = () => {
  const { t } = useTranslation();
  const { formData, handleChange, handleSubmit, message, isLoading } = useForm();

  return (
    <>
      <SocialBar />

      <form
        onSubmit={handleSubmit}
        className="max-w-4xl mx-auto my-8 p-4 md:p-6 bg-lightGreen bg-opacity-80 dark:bg-black 
        dark:bg-opacity-90 text-primary shadow-lg rounded-lg w-full font-body 
        border border-secondary"
      >
        {/* TÍTULO PRINCIPAL */}
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center text-primary dark:text-secondary mb-4 font-heading tracking-wide animate__animated animate__fadeInDown leading-tight text-wrap balance">
          {t("form.title.part1")}{" "}
          <span className="text-[#E0BB44] dark:text-lightGreen font-extrabold">
            {t("form.title.highlight1")}
          </span>{" "}
          <br className="sm:hidden" />
          {t("form.title.part2")}{" "}
          <span className="text-[#E0BB44] dark:text-lightGreen font-extrabold whitespace-nowrap">
            {t("form.title.highlight2")}
          </span>{" "}
          {t("form.title.end")}
        </h2>

        <h3 className="text-2xl font-bold text-center uppercase tracking-wide text-primary dark:text-secondary [text-shadow:_1px_1px_3px_rgba(1,51,51,0.6)]">
          {t("form.waitingList")}
        </h3>

        {/* CAMPOS DEL FORMULARIO */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {/* First Name */}
          <div>
            <label htmlFor="firstName" className="block font-semibold dark:text-lightGreen">
              {t("form.fields.firstName")} <span className="text-red-500">*</span>
            </label>
            <Input
              type="text"
              name="firstName"
              placeholder={t("form.placeholders.firstName")}
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label htmlFor="email" className="block font-semibold dark:text-lightGreen">
              {t("form.fields.email")} <span className="text-red-500">*</span>
            </label>
            <Input
              type="email"
              name="email"
              placeholder={t("form.placeholders.email")}
              value={formData.email}
              onChange={handleChange}
              required
              className="p-3 border-2 border-primary rounded-lg w-full focus:ring-2 focus:ring-secondary transition-all duration-300"
            />
          </div>
        </div>

        {/* Teléfono */}
        <div className="mt-6">
          <label htmlFor="phone" className="block font-semibold dark:text-lightGreen">
            {t("form.fields.phone")} <span className="text-red-500">*</span>
          </label>
          <PhoneInput
            country={"fr"}
            value={formData.phone}
            onChange={(phone) =>
              handleChange({ target: { name: "phone", value: phone } })
            }
            required
            inputStyle={{ width: "100%", paddingLeft: "50px", height: "44px" }}
            buttonStyle={{ background: "white", border: "1px solid #ccc" }}
            containerStyle={{ width: "100%" }}
            specialLabel=""
          />
        </div>

        {/* Instagram & LinkedIn */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div>
            <label htmlFor="instagram" className="block font-semibold dark:text-lightGreen">
              {t("form.fields.instagram")}
            </label>
            <Input
              type="text"
              name="instagram"
              placeholder={t("form.placeholders.instagram")}
              value={formData.instagram}
              onChange={handleChange}
              className="p-3 border-2 border-primary rounded-lg w-full focus:ring-2 focus:ring-secondary transition-all duration-300"
            />
          </div>

          <div>
            <label htmlFor="linkedin" className="block font-semibold dark:text-lightGreen">
              {t("form.fields.linkedin")}
            </label>
            <Input
              type="text"
              name="linkedin"
              placeholder={t("form.placeholders.linkedin")}
              value={formData.linkedin}
              onChange={handleChange}
              className="p-3 border-2 border-primary rounded-lg w-full focus:ring-2 focus:ring-secondary transition-all duration-300"
            />
          </div>
        </div>

        {/* Preferencia de contacto */}
        <div className="mt-6">
          <label htmlFor="preferredContact" className="block font-semibold dark:text-lightGreen">
            {t("form.fields.preferredContact")} <span className="text-red-500">*</span>
          </label>
          <select
            name="preferredContact"
            value={formData.preferredContact}
            onChange={handleChange}
            className="w-full p-3 border border-primary rounded-lg bg-secondary text-black focus:ring-2 focus:ring-primary"
            required
          >
            <option value="">{t("form.select.default")}</option>
            <option value="Sloworker">{t("form.select.sloworker")}</option>
            <option value="Host">{t("form.select.host")}</option>
            <option value="Bussines">{t("form.select.business")}</option>
          </select>
        </div>

        {/* Interés en la comunidad */}
        <div className="mt-6">
          <label htmlFor="communityInterest" className="block font-semibold dark:text-lightGreen">
            {t("form.fields.communityInterest")} <span className="text-red-500">*</span>
          </label>
          <textarea
            name="communityInterest"
            placeholder={t("form.placeholders.communityInterest")}
            value={formData.communityInterest}
            onChange={handleChange}
            className="p-3 border-2 border-primary rounded-lg w-full focus:ring-2 focus:ring-secondary transition-all duration-300"
            required
          />
        </div>
        <div style={{ marginTop: "1.5rem" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <input
              type="checkbox"
              name="termsandConditions"
              id="termsandConditions"
              required
              style={{
                width: "27px",
                height: "27px",
                borderRadius: "4px",
                transition: "all 0.3s ease",
                cursor: "pointer",
                margin: "0px 5px 0px 7px"
              }}
            />
            <label
              htmlFor="termsandConditions"
              style={{
                fontWeight: 600,
                cursor: "pointer",
                padding: "2px",
              }}
            >
              {t("form.fields.terms")}
              <Link to="/terms-and-conditions" className="hover:text-secondary">{t("footer.terms")}</Link>
              {t("form.fields.termsEnd")}
              <span style={{ color: "red" }}>*</span>
            </label>
          </div>
        </div>
        <Button
          type="submit"
          disabled={isLoading}
          className={`w-full mt-6 py-3 rounded-lg font-semibold transition-all duration-300 relative ${
            isLoading 
              ? "bg-gray-400 cursor-not-allowed" 
              : "bg-primary text-white hover:bg-secondary active:scale-95"
          }`}
        >
          {isLoading ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
              {t("form.loading") || "Sending..."}
            </div>
          ) : (
            t("form.button")
          )}
        </Button>

        {/* LOADER OVERLAY */}
        {isLoading && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-8 flex flex-col items-center shadow-2xl">
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary border-t-transparent mb-4"></div>
              <p className="text-lg font-semibold text-primary dark:text-secondary">
                {t("form.processing") || "Processing your request..."}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                {t("form.pleasewait") || "Please wait a moment"}
              </p>
            </div>
          </div>
        )}

        {/* MENSAJE DE CONFIRMACIÓN */}
        {message && (
          <p
            className={`mt-4 text-center text-lg font-semibold ${message.startsWith("✅") ? "text-green-600" : "text-red-600"
              }`}
          >
            {message}
          </p>
        )}
      </form>
    </>
  );
};

export default Form;
